/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Rotate_Salary_PitchInputs */

const en_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`salary pitch`)
};

const de_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehaltsvorschlag`)
};

const fr_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pitch salarial`)
};

const es_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`propuesta salarial`)
};

const it_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proposta salariale`)
};

const nl_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`salarispitch`)
};

const pl_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ofertę płacową`)
};

const fi_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`palkkaehdotuksesi`)
};

const da_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lønudspil`)
};

const sv_landing_hero_rotate_salary_pitch = /** @type {(inputs: Landing_Hero_Rotate_Salary_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lönepitch`)
};

/**
* | output |
* | --- |
* | "salary pitch" |
*
* @param {Landing_Hero_Rotate_Salary_PitchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_hero_rotate_salary_pitch = /** @type {((inputs?: Landing_Hero_Rotate_Salary_PitchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Rotate_Salary_PitchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_hero_rotate_salary_pitch(inputs)
	if (locale === "fr") return fr_landing_hero_rotate_salary_pitch(inputs)
	if (locale === "es") return es_landing_hero_rotate_salary_pitch(inputs)
	if (locale === "it") return it_landing_hero_rotate_salary_pitch(inputs)
	if (locale === "nl") return nl_landing_hero_rotate_salary_pitch(inputs)
	if (locale === "pl") return pl_landing_hero_rotate_salary_pitch(inputs)
	if (locale === "fi") return fi_landing_hero_rotate_salary_pitch(inputs)
	if (locale === "da") return da_landing_hero_rotate_salary_pitch(inputs)
	if (locale === "sv") return sv_landing_hero_rotate_salary_pitch(inputs)
	return en_landing_hero_rotate_salary_pitch(inputs)
});